import React, { useState } from "react";

const ItemForm = () => {
  const [productName, setProductName] = useState("");
  const [category, setCategory] = useState("");
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const [delivery, setDelivery] = useState("");
  const [longDescription, setLongDescription] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [discount, setDiscount] = useState(false);
  // const [image, setImage] = useState(null); // State to store the uploaded image
  const [imagePreview, setImagePreview] = useState(null); // State to store the image preview URL

  // Function to handle image upload
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
   // setImage(file);
    setImagePreview(URL.createObjectURL(file)); // Create a preview URL for the image
  };

  return (
    <div className="bg-white shadow-lg p-8 rounded-md w-full max-w-4xl">
      <h2 className="text-xl font-semibold mb-4">Add Product</h2>
      <form>
        {/* Product Name */}
        <div className="mb-4">
          <label className="block text-gray-700">Product Name</label>
          <input
            type="text"
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
          />
        </div>

        {/* Select Category */}
        <div className="mb-4">
          <label className="block text-gray-700">Select Product Category</label>
          <select
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="">Select Category</option>
            <option value="food">Food</option>
            <option value="drink">Drink</option>
          </select>
        </div>

        {/* Price and Quantity */}
        <div className="mb-4 grid grid-cols-2 gap-4">
          <div>
            <label className="block text-gray-700">Selling Price</label>
            <input
              type="number"
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-gray-700">Quantity in Stock</label>
            <input
              type="number"
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
          </div>
        </div>

        {/* Delivery */}
        <div className="mb-4">
          <label className="block text-gray-700">Delivery</label>
          <select
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
            value={delivery}
            onChange={(e) => setDelivery(e.target.value)}
          >
            <option value="">Select Delivery Type</option>
            <option value="home">Home Delivery</option>
            <option value="pickup">Pick Up</option>
          </select>
        </div>

        {/* Product Long Description */}
        <div className="mb-4">
          <label className="block text-gray-700">Product Long Description</label>
          <textarea
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
            value={longDescription}
            onChange={(e) => setLongDescription(e.target.value)}
          />
        </div>

        {/* Discount */}
        <div className="mb-4">
          <label className="block text-gray-700">Discount</label>
          <input
            type="checkbox"
            className="mr-2"
            checked={discount}
            onChange={(e) => setDiscount(e.target.checked)}
          />
        </div>

        {/* Expiry Date */}
        <div className="mb-4">
          <label className="block text-gray-700">Expiry Date</label>
          <input
            type="date"
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
            value={expiryDate}
            onChange={(e) => setExpiryDate(e.target.value)}
          />
        </div>

        {/* Image Upload */}
        <div className="mb-4">
          <label className="block text-gray-700">Upload Image</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
          />
          {imagePreview && (
            <div className="mt-4">
              <p className="text-gray-700">Image Preview:</p>
              <img
                src={imagePreview}
                alt="Product Preview"
                className="w-40 h-40 object-cover border border-gray-300 mt-2"
              />
            </div>
          )}
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="bg-orange-500 text-white px-4 py-2 rounded-md"
        >
          Save
        </button>
      </form>
    </div>
  );
};

export default ItemForm;